import { motion } from 'framer-motion';

const keyNumbers = [
  { value: '+5.000', label: 'equipos' },
  { value: '+48.000', label: 'jugadores' },
  { value: '+260', label: 'torneos' },
] as const;

export function KeyNumbersSection() {
  return (
    <section className="border-b border-brand-border bg-gradient-to-b from-brand-yellow/[0.07] to-transparent px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto grid w-full max-w-5xl grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-6">
        {keyNumbers.map((item, index) => (
          <motion.div
            key={item.label}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: index * 0.08, duration: 0.45 }}
            className="flex flex-col items-center text-center"
          >
            <p className="font-display text-4xl font-extrabold tracking-tight text-brand-yellow sm:text-5xl">
              {item.value}
            </p>
            <p className="mt-2 text-sm font-medium uppercase tracking-[0.18em] text-zinc-300">
              {item.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
